import { parseQueryString } from 'utilities/transformer'
import { createHashHistory } from 'history'

import config from 'config/config'

import actions from './actions'

const history = createHashHistory()
const { websocketURL } = config

const initialState = {
  id: '',
  role: 'user',
  avatar: '',
  authorized: false,
  isUserLoggedIn: false,

  name: '',
  firstName: '',
  lastName: '',
  email: '',
  userId: '',
  clientId: '',
  isEmailVerfied: false,
  loading: false,
  isUserRegistered: false,
  isMFAset: undefined,
  isUserRequestedMFA: undefined,
  isPreQualificationSetup: undefined,
  isTwoMFACodeVerfied: true,
  token: '',
  mfaToken: '',
  refreshToken: '',
  barcode: '',
  barCodeSecretKey: '',

  // new
  isUserPasswordUpdated: true,
  userInformation: {},
  userProfile: {},
  ws: {},
  loginUrl: '/auth/login',
  userData: [],
  agentUsers: [],
  clientUsers: [],
}

export default function userReducer(state = initialState, action) {
  const { location } = history
  if (action.type === '@@router/LOCATION_CHANGE') {
    if (action.payload.location.pathname === '/auth/login') {
      return {
        ...state,
        isAuthDeprecated: false,
        loginUrl: '/auth/login',
      }
    }
    if (action.payload.location.pathname === '/auth/old-login') {
      return {
        ...state,
        isAuthDeprecated: true,
        loginUrl: '/auth/old-login',
      }
    }
  }
  const token = parseQueryString(location.search).token
    ? encodeURIComponent(parseQueryString(location.search).token)
    : undefined

  if (token !== undefined && action.type === '@@router/LOCATION_CHANGE') {
    const { pathname, search } = location

    return {
      ...state,
      passwordResetToken: token,
      passwordResetPath: `${pathname}${search}`,
    }
  }

  if (state.authorized) {
    if (state.ws) {
      if (state.ws.readyState === undefined) {
        const ws = new WebSocket(`${websocketURL}?user=${state.email}`)
        return {
          ...state,
          ws,
        }
      }
    }
  }

  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.REGISTER:
      return {
        ...state,
        loading: true,
        email: action.payload.email,
      }
    case actions.REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.value.access_token,
        refreshToken: action.value.refresh_token,
        isUserRegistered: !state.isUserRegistered,
      }
    case actions.REGISTER_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case actions.LOGIN:
      return {
        ...state,
        loading: true,
        email: action.payload.email,
      }
    case actions.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isUserLoggedIn: true,
        token: action.value.access_token,
        refreshToken: action.value.refresh_token,
        // isMFAset: action.value && action.value.isMFAset,
        isUserRequestedMFA: action.value && action.value.mfa_required,
        mfaToken: action.value && action.value.mfa_token,
      }
    case actions.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case actions.CHANGE_PASSWORD:
      return {
        ...state,
        loading: true,
      }
    case actions.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        isUserPasswordUpdated: !state.isUserPasswordUpdated,
      }
    case actions.CHANGE_PASSWORD_FALIURE:
      return {
        ...state,
        loading: false,
      }

    // get user info
    case actions.GET_USER_DATA:
      return {
        ...state,
        loading: true,
      }
    case actions.GET_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        authorized: true,
        isEmailVerfied: action.value.emailVerified,
        isMFAset: action.value && action.value.mfaEnabled,
        email: action.value.email,
        userId: action.value.id,
        clientId: action.value.entityId,
        //         isPreQualificationSetup: action.value.entity.isPreQualificationSetup,
        name: `${action.value.firstName} ${action.value.lastName}`,
        firstName: action.value.firstName,
        lastName: action.value.lastName,
        userProfile: { ...action.value },
      }
    case actions.GET_USER_DATA_FAILURE:
      return {
        ...state,
        loading: false,
      }

    // reset password
    case actions.RESET_PASSWORD:
      return {
        ...state,
        loading: true,
      }
    case actions.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case actions.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
      }

    // email verfication link

    case actions.EMAIL_VERIFICATION_LINK:
      return {
        ...state,
        loading: true,
      }
    case actions.EMAIL_VERIFICATION_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case actions.EMAIL_VERIFICATION_LINK_FAILURE:
      return {
        ...state,
        loading: false,
      }

    // 2fa
    case actions.SETUP_MFA_AUTHENTICATOR:
      return {
        ...state,
        loading: true,
      }
    case actions.SETUP_MFA_AUTHENTICATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        barcode: action.value.barcodeUri,
        barCodeSecretKey: action.value.secret,
      }
    case actions.SETUP_MFA_AUTHENTICATOR_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case actions.INITIAL_AUTHORIZE_2FA_CODE:
      return {
        ...state,
        loading: true,
      }
    case actions.INITIAL_AUTHORIZE_2FA_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.value.access_token,
      }
    case actions.INITIAL_AUTHORIZE_2FA_CODE_FAILURE:
      return {
        ...state,
        loading: false,
      }

    case actions.AUTHORIZE_2FA_CODE:
      return {
        ...state,
        loading: true,
      }
    case actions.AUTHORIZE_2FA_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.value.access_token,
      }
    case actions.AUTHORIZE_2FA_CODE_FAILURE:
      return {
        ...state,
        loading: false,
      }
    // case actions.AUTHORIZE_APP:
    //   return {
    //     ...state,
    //     loading: false,
    //     authorized: true,
    //   }

    // send another link to verify email

    case actions.SEND_EMAIL_CONFIRM_LINK:
      return {
        ...state,
        loading: true,
      }
    case actions.SEND_EMAIL_CONFIRM_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case actions.SEND_EMAIL_CONFIRM_LINK_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case actions.IS_MFA_ENABLED:
      return {
        ...state,
        loading: true,
      }
    case actions.IS_MFA_ENABLED_SUCCESS:
      return {
        ...state,
        loading: false,
        isMFAset: action.value === null && false,
        barcode: action.value !== null && action.value.barcode_uri,
        barCodeSecretKey: action.value !== null && action.value.secret,
      }
    case actions.IS_MFA_ENABLED_FAILURE:
      return {
        ...state,
        loading: false,
      }

    case actions.VERIFY_2FA_CODE:
      return {
        ...state,
        loading: true,
      }
    case actions.VERIFY_2FA_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        isMFAset: true,
        isTwoMFACodeVerfied: !state.isTwoMFACodeVerfied,
      }
    case actions.VERIFY_2FA_CODE_FAILURE:
      return {
        ...state,
        loading: false,
      }
    default:
      return state
  }
}
